import { Row, Col, Spinner } from 'reactstrap';
const Spinners = () => {
  return (
    <div style={{ height: '100vh' }}>
      {' '}
      {/* Para ocupar toda la pantalla */}
      <Row className="justify-content-center align-items-center h-100">
        <Col xs="12" md="6" className="d-flex justify-content-center align-items-center">
          <Spinner color="primary" />
        </Col>
      </Row>
    </div>
  );
};

export default Spinners;
